import clsx from "clsx"
import { ProductDetailText, ProductDetailTexts } from "./ProductDetailText"
import { ImageMagnifier } from "./ZoomableImage"
import { formatNumber } from "@/app/utils/helpers"

const ProductDisplay = ({ product }) => {
  return (
    product &&
    <article className={clsx("mb-4 sm:mb-0", { "col-span-2": product.isSingle })}>
      <section>
        <div className="mb-1 sm:mb-2 lg:mb-3">
          <ImageMagnifier product={product} />
        </div>
        <h1 className="font-agcasmlt text-charcoal-black text-xl sm:text-2xl lg:text-3xl font-semibold mb-1 sm:mb-2 lg:mb-3">
          {product.name}
          {product.variant &&
            <span className="block">{product.variant}</span>
          }
        </h1>
        {/* TODO: buat dia rata bawah klo bisa */}
        <div className="flex justify-between">
          {product.isSingle && product.types && product.types.length > 0 ?
            <div className="flex gap-8 sm:gap-12 lg:gap-16">
              {product.types.map((type, idx) => (
                <div key={idx}>
                  <ProductDetailText text={type.name} />
                  <ProductDetailTexts ph={type} />
                </div>
              ))}
            </div>
            :
            <div>
              <ProductDetailTexts ph={product} />
            </div>
          }
          {/* <div className="flex items-end"> */}
          <div>
            <div>
              {product.price ?
                <ProductDetailText isJustifyLeft text={`Rp${formatNumber(product.price)}`} /> :
                product.prices.map((pr, idx) => (
                  <ProductDetailText isJustifyLeft key={idx} label={`${pr.piece} ${pr.piece > 1 ? "pieces" : "piece"}`} text={`Rp${formatNumber(pr.price)}`} />
                ))}
            </div>
          </div>
        </div>
      </section>
    </article>
  )
}

export default ProductDisplay